var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04622 0.686523C1.36604 0.686523 0 2.04522 0 3.71637V18.8656C0 20.5368 1.36604 21.8955 3.04622 21.8955H18.2773C19.9575 21.8955 21.3235 20.5368 21.3235 18.8656V3.71637C21.3235 2.04522 19.9575 0.686523 18.2773 0.686523H3.04622ZM15.5072 5.78519L16.1926 6.46691C16.9351 7.20544 16.9351 8.40317 16.1926 9.14643L15.174 10.1595L11.7946 6.7983L12.8132 5.78519C13.5557 5.04667 14.7599 5.04667 15.5072 5.78519ZM5.7069 12.8533L10.7141 7.87295L14.0935 11.2342L9.0863 16.2098C8.89115 16.4039 8.64841 16.5412 8.3771 16.6074L5.51651 17.3176C5.25473 17.3838 4.98342 17.3081 4.79303 17.1187C4.60265 16.9294 4.52649 16.6595 4.59313 16.3991L5.30708 13.5539C5.37372 13.2888 5.51175 13.0426 5.7069 12.8485V12.8533Z",
    fill: "#5B6673"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/edit-square.34b3e98c9582f23a7a45e908bd0eefca.svg";
export { ForwardRef as ReactComponent };